"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardSelect = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Type_1 = require("@nerdwallet/currency/components/Type");
var card_select_module_css_1 = __importDefault(require("./card-select.module.css"));
/**
 * `CardSelect` components present a list of options for a user to choose from. The option selected
 * influences or changes the experience. Users can select a single option from the list.
 *
 * This iteration deprecates the multiple prop until usability issues are resolved. Please reach out
 * for more details.
 */
exports.CardSelect = react_1.default.forwardRef(function (props, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref) {
    var autoFocus = props.autoFocus, className = props.className, dangerouslyForceActiveStyling = props.dangerouslyForceActiveStyling, dangerouslyForceFocusStyling = props.dangerouslyForceFocusStyling, dangerouslyForceHoverStyling = props.dangerouslyForceHoverStyling, dangerouslyForceSelectedStyling = props.dangerouslyForceSelectedStyling, disabled = props.disabled, nameProp = props.name, maxSelectedOptions = props.maxSelectedOptions, multiSelect = props.multiSelect, onChange = props.onChange, options = props.options, selectedValue = props.value, otherProps = __rest(props, ["autoFocus", "className", "dangerouslyForceActiveStyling", "dangerouslyForceFocusStyling", "dangerouslyForceHoverStyling", "dangerouslyForceSelectedStyling", "disabled", "name", "maxSelectedOptions", "multiSelect", "onChange", "options", "value"]);
    var castArray = function (value) {
        if (Array.isArray(value)) {
            return value;
        }
        else {
            return [value];
        }
    };
    var buildMultiSelectValue = function (value) {
        var currentSelection = selectedValue !== null && selectedValue !== void 0 ? selectedValue : [];
        var multiSelectValue = castArray(currentSelection);
        if (!multiSelectValue.includes(value) &&
            (!maxSelectedOptions || multiSelectValue.length < maxSelectedOptions)) {
            return __spreadArray(__spreadArray([], multiSelectValue, true), [value], false);
        }
        return multiSelectValue.filter(function (el) { return el !== value; });
    };
    var createChangeHandler = function (value) { return function () {
        if (multiSelect) {
            var newValue = buildMultiSelectValue(value);
            onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange(value);
        }
    }; };
    var selectedOptionsCount = Array.isArray(selectedValue)
        ? selectedValue.length
        : 0;
    var multiSelectionLabelText = "".concat(selectedOptionsCount, " of ").concat(!maxSelectedOptions || maxSelectedOptions === 0
        ? options.length
        : maxSelectedOptions, " options selected");
    var multiSelectionLabel = multiSelect && maxSelectedOptions !== 1 ? (react_1.default.createElement(Type_1.Type, { "aria-valuenow": selectedOptionsCount, "aria-valuemin": 0, "aria-valuemax": maxSelectedOptions, "aria-label": multiSelectionLabelText, className: card_select_module_css_1.default.multiSelectionLabel, color: "neutral-darker", size: 1 }, multiSelectionLabelText)) : null;
    // `name` is used to link related radio buttons together for keyboard
    // navigation. If the name isn't provided, we can use `useId()` to generate
    // one, since it doesn't really matter what the name is as long as it's a
    // globally-unique string.
    var name = "".concat(nameProp, "-").concat(Math.random().toString());
    // disabling this rule because we do use nesting by putting the input inside of the label
    // this is valid according to this page https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/label-has-for.md
    return (react_1.default.createElement(react_1.default.Fragment, null,
        multiSelectionLabel,
        react_1.default.createElement("div", __assign({}, otherProps, { className: (0, classnames_1.default)(card_select_module_css_1.default.container, className), ref: ref }), options.map(function (_a, index) {
            var _b;
            var label = _a.label, value = _a.value, optionDisabled = _a.disabled, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c;
            var isChecked = multiSelect && Array.isArray(selectedValue)
                ? selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.includes(value)
                : value === selectedValue;
            // only pass this prop in if props.autoFocus is true
            var autoFocusProp = 
            // use autoFocus on the first selected card, and if none are selected, the first card
            autoFocus && (selectedValue ? isChecked : index === 0);
            var isDisabled = disabled ||
                optionDisabled ||
                (!isChecked &&
                    selectedOptionsCount === maxSelectedOptions &&
                    maxSelectedOptions > 0);
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)(card_select_module_css_1.default.option, className), key: value.toString() },
                react_1.default.createElement("label", { className: (0, classnames_1.default)(card_select_module_css_1.default.label, (_b = {},
                        _b[card_select_module_css_1.default.labelSelected] = isChecked,
                        _b[card_select_module_css_1.default.disabled] = isDisabled,
                        _b[card_select_module_css_1.default["force-active"]] = dangerouslyForceActiveStyling,
                        _b[card_select_module_css_1.default["force-focus"]] = dangerouslyForceFocusStyling,
                        _b[card_select_module_css_1.default["force-hover"]] = dangerouslyForceHoverStyling,
                        _b[card_select_module_css_1.default["force-selected"]] = dangerouslyForceSelectedStyling,
                        _b[card_select_module_css_1.default.multiSelect] = multiSelect,
                        _b)) },
                    label,
                    react_1.default.createElement("input", { autoFocus: autoFocusProp, onClick: onClick, type: multiSelect ? "checkbox" : "radio", className: card_select_module_css_1.default.input, onChange: createChangeHandler(value), checked: isChecked, disabled: isDisabled, name: name }))));
        }))));
});
exports.CardSelect.displayName = "CardSelect";
